/*
document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.hero-banner.swiper', {
    loop: true,
    autoplay: {
      delay: 500000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    effect: 'slide', // hoặc 'fade' nếu muốn hiệu ứng mờ dần
  });
});
*/

class HeroBanner extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.config = {
      autoplay: this.dataset.autoplay === 'true',
      autoplaySpeed: parseInt(this.dataset.autoplaySpeed, 10) || 5000,
      navigation: this.dataset.navigation === 'true',
      pagination: this.dataset.pagination === 'true',
    };
  }

  connectedCallback() {
    this.init();
  }
  
  init() {
    // Ví dụ nếu dùng Swiper.js
    this.swiper = new Swiper(this.querySelector('.swiper'), {
      loop: true,
      autoplay: this.config.autoplay
        ? { delay: this.config.autoplaySpeed, disableOnInteraction: false }
        : false,
      navigation: this.config.navigation
        ? { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }
        : false,
      pagination: this.config.pagination
        ? { el: '.swiper-pagination', clickable: true }
        : false,
    });
  }
}

customElements.define('hero-banner', HeroBanner);